const getAnalyticsConfig = require('../../../common/getAnalyticsConfig');
const { internalEventCenter } = require('../events');

const analyticsConfig = getAnalyticsConfig();
/**
 * Enum of known traffic sources.
 * @readonly
 * @enum {string}
 */
const SOURCES = {
    ABANDONED_CART_EMAIL: analyticsConfig.referral.sources.abandonedCartEmail,
    NEWSLETTER: analyticsConfig.referral.sources.facebook,
    FACEBOOK: analyticsConfig.referral.sources.google,
    GOOGLE: analyticsConfig.referral.sources.newsletter,
    OTHER: analyticsConfig.referral.sources.other
};

/**
 * Middleware that enriches payload with referral info.
 *
 * @param {Object} payload - Original event payload
 * @returns {Object} Modified payload with referral info
 */
function referralMiddleware(payload) {
    const params = new URLSearchParams(window.location.search);

    // Detect abandoned cart email aliases
    const isAbandonedCartEmail = params.get('source') === 'igodigital'
        || params.get('utm_source') === 'carrito_abandonado';

    // Determine referral source
    let source = SOURCES.OTHER;
    if (isAbandonedCartEmail) source = SOURCES.ABANDONED_CART_EMAIL;
    else if (params.get('utm_source') === 'newsletter') source = SOURCES.NEWSLETTER;
    else if (params.get('utm_source') === 'facebook') source = SOURCES.FACEBOOK;
    else if (params.get('utm_source') === 'google') source = SOURCES.GOOGLE;

    return {
        ...payload,
        referral: {
            source,
            referrerUrl: document.referrer || null
        }
    };
}

/**
 * Initialize the middleware, associating it to the events
 */
function appendReferralMiddleware() {
    internalEventCenter.appendMiddleware(
        internalEventCenter.EVENTS.pageviewLoaded,
        referralMiddleware
    );
}

module.exports = {
    appendReferralMiddleware
};
